module.exports = __webpack_public_path__ + "img/how-work-6.c7809bd9.png";